import { render, staticRenderFns } from "./editBusi.vue?vue&type=template&id=5862c42b&scoped=true&"
import script from "./editBusi.vue?vue&type=script&lang=js&"
export * from "./editBusi.vue?vue&type=script&lang=js&"
import style0 from "./editBusi.vue?vue&type=style&index=0&id=5862c42b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862c42b",
  null
  
)

export default component.exports